import { useKeyboardControls } from '../../../contexts/KeyboardControlsContext'
import { HighlightEffect } from '../../../enums/KeyboardControls'
import ControlHighlight from '../KeyboardControls/ControlHighlight'
import KeyboardControl from '../KeyboardControls/KeyboardControl'

interface PoliciesProps {
  id: string
};

/**
 * Renders privacy policy and terms of use links.
 */
const Policies: React.FC<PoliciesProps> = ({
  id
}: PoliciesProps) => {
  const keyboardControls = useKeyboardControls()

  const idLinkPrivacyPolicy = `${id}-link-privacy-policy`
  const idLinkTerms = `${id}-link-terms`

  return (
    <div className='text-[18px] font-bold flex items-end gap-8'>
      <ControlHighlight
        active={keyboardControls.isEnabled && keyboardControls.isElementFocused(idLinkPrivacyPolicy)}
        highlightEffect={HighlightEffect.LinkUnderline}
      >
        <KeyboardControl>
          <a
            id={idLinkPrivacyPolicy}
            className='underline text-dopage-primary'
            href='https://dopa.ge/privacypolicy'
            target='_blank'
            rel='noreferrer'
          >
            Privacy Policy
          </a>
        </KeyboardControl>
      </ControlHighlight>
      <ControlHighlight
        active={keyboardControls.isEnabled && keyboardControls.isElementFocused(idLinkTerms)}
        highlightEffect={HighlightEffect.LinkUnderline}
      >
        <KeyboardControl>
          <a
            id={idLinkTerms}
            className='underline text-dopage-primary'
            href='https://dopa.ge/terms-of-use'
            target='_blank'
            rel='noreferrer'
          >
            Terms of Use
          </a>
        </KeyboardControl>
      </ControlHighlight>
    </div>
  )
}

export default Policies
